import { connect } from 'react-redux';

import { IMortgageSimpleBannerOwnProps, IMortgageSimpleBannerStateProps, MortgageSimpleBanner } from './mortgage';
import { IAppState } from '../../../../../common/state';
import { prepareTrackingData } from '../../../../../utils/prepareTrackingData';
import { isRedesignExperimentEnabled } from '../../../../../selectors/isRedesignExperimentEnabled';

export function mapStateToProps(state: IAppState): IMortgageSimpleBannerStateProps {
  const { filters, results, userGADataLayerData, breadcrumbs } = state;

  return {
    isRedesignEnabled: isRedesignExperimentEnabled(state),
    tracking: prepareTrackingData(filters, results, breadcrumbs, userGADataLayerData),
  };
}

export const MortgageSimpleBannerContainer = connect<
  IMortgageSimpleBannerStateProps,
  {},
  IMortgageSimpleBannerOwnProps
>(mapStateToProps)(MortgageSimpleBanner);
